import { showConfirmDialog, showDialog } from "vant";
export default {
  name: "Customize",
  data: function data() {
    return {
      customize: {},
      btnDisabled: false
    };
  },
  methods: {
    //提交订单
    submitCustomize: function submitCustomize() {
      var _this = this;

      this.customize.resource = window.$customerName;
      var url = "/ad-server/customize";
      showConfirmDialog({
        title: '个性定制',
        message: '确定要提交个性定制要求吗？'
      }).then(function () {
        _this.btnDisabled = true;

        _this.$axios.post(url, _this.customize).then(function () {
          showDialog({
            message: "您的需求提交成功，请注意接听客服来电！"
          }); //清除表单信息

          _this.customize = {};
          _this.btnDisabled = false;
        });
      }).catch(function () {// on cancel
      });
    }
  }
};